// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".props-container[data-v-44452602]{margin-bottom:10px}.show-more[data-v-44452602]{color:#878787;cursor:pointer;text-align:right;-webkit-text-decoration:underline;text-decoration:underline}header[data-v-44452602]{color:#3b3b3b;margin-bottom:4px}.item[data-v-44452602]{align-items:flex-end;color:#878787;display:flex;gap:10px;justify-content:space-between;margin-bottom:7px}.amount[data-v-44452602]{white-space:nowrap}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
